export default __webpack_public_path__ + "static/media/greyCloudFormation.20b69d73.svg";